import { render, staticRenderFns } from "./IdCardOcr.vue?vue&type=template&id=65748282&scoped=true&"
import script from "./IdCardOcr.vue?vue&type=script&lang=ts&"
export * from "./IdCardOcr.vue?vue&type=script&lang=ts&"
import style0 from "./IdCardOcr.vue?vue&type=style&index=0&id=65748282&lang=less&scoped=true&"
import style1 from "./IdCardOcr.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65748282",
  null
  
)

export default component.exports